export enum TokenType {
  REFRESH_TOKEN = 'refresh_token',
  ACCESS_TOKEN = 'token'
}

export enum TableData {
  EMPTY = '-'
}
